/**
 * FormaPagamentoLocalRepository
 *
 * Abstrai o acesso às formas de pagamento armazenadas localmente via Electron IPC.
 */
import { getElectronAPI } from "@/plugins/desktop";

const FormaPagamentoLocalRepository = {
  _api() {
    return getElectronAPI();
  },

  async listar() {
    return this._api().formasPagamento.listar();
  },

  async salvar(formas) {
    return this._api().formasPagamento.salvar(formas);
  },

  async buscarPadrao() {
    return this._api().formasPagamento.buscarPadrao();
  },

  async contar() {
    return this._api().formasPagamento.contar();
  },
};

export default FormaPagamentoLocalRepository;
